/**
 * Reusable skeleton loading placeholders for mobile.
 * Usage: <MobileSkeleton type="dashboard" /> or <MobileSkeleton type="list" />
 */

const shimmer = {
  background: 'linear-gradient(90deg, var(--s1) 25%, var(--s2) 50%, var(--s1) 75%)',
  backgroundSize: '200% 100%',
  animation: 'dmShimmer 1.5s infinite',
  borderRadius: 8,
};

const styles = `
@keyframes dmShimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
`;

function Bar({ w = '100%', h = 12, mb = 8 }) {
  return <div style={{ ...shimmer, width: w, height: h, marginBottom: mb }} />;
}

function Card({ children }) {
  return (
    <div style={{ background: 'var(--s1)', border: '1px solid var(--bdr)', borderRadius: 12, padding: 16, marginBottom: 8 }}>
      {children}
    </div>
  );
}

export function SkeletonDashboard() {
  return (
    <div style={{ padding: 16 }}>
      <style>{styles}</style>
      <Bar w="40%" h={20} mb={4} />
      <Bar w="60%" h={14} mb={16} />
      {/* KPI cards */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 16 }}>
        {[1,2,3,4].map(i => <Card key={i}><Bar w="50%" h={10} /><Bar w="70%" h={24} mb={4} /><Bar w="80%" h={10} /></Card>)}
      </div>
      {/* Tab bar */}
      <Bar w="100%" h={40} mb={12} />
      {/* Task items */}
      {[1,2,3,4,5].map(i => <Card key={i}><Bar w="75%" h={14} /><Bar w="50%" h={10} /></Card>)}
    </div>
  );
}

export function SkeletonList() {
  return (
    <div style={{ padding: 16 }}>
      <style>{styles}</style>
      <Bar w="30%" h={18} mb={4} />
      <Bar w="50%" h={10} mb={16} />
      <Bar w="100%" h={36} mb={12} />
      {[1,2,3,4,5,6,7].map(i => (
        <Card key={i}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ ...shimmer, width: 36, height: 36, borderRadius: '50%', flexShrink: 0 }} />
            <div style={{ flex: 1 }}>
              <Bar w="60%" h={14} mb={4} />
              <Bar w="40%" h={10} />
            </div>
            <Bar w={50} h={20} />
          </div>
        </Card>
      ))}
    </div>
  );
}

export function SkeletonDetail() {
  return (
    <div style={{ padding: 16 }}>
      <style>{styles}</style>
      <Bar w="20%" h={12} mb={12} />
      <Bar w="70%" h={24} mb={6} />
      <Bar w="50%" h={12} mb={20} />
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        <Bar w={80} h={32} /><Bar w={80} h={32} /><Bar w={80} h={32} />
      </div>
      <Card><Bar w="100%" h={80} /></Card>
      <Card><Bar w="60%" h={14} mb={8} /><Bar w="90%" h={10} /><Bar w="75%" h={10} /></Card>
      <Card><Bar w="40%" h={14} mb={8} /><Bar w="100%" h={60} /></Card>
    </div>
  );
}

export default function MobileSkeleton({ type = "list" }) {
  if (type === "dashboard") return <SkeletonDashboard />;
  if (type === "detail") return <SkeletonDetail />;
  return <SkeletonList />;
}
